import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import FetchOrderStatus from './pages/fetch';
import ClientOrderStatus from './pages/fetchClientOrder';
import KitschOrderStatus from './pages/kitsch';
import ClientKitschOrderStatus from './pages/fetchKitschClientOrder';
import KitschOrderDetailUpdate from './pages/kitschOrderDetailUpdate';
import OrdersTable from './dihShopifyOrders/orders';
import OrderBulkStatus from './dihShopifyOrders/orderBulkStatus';
import DrmtlgyOrderBulkStatus from './drmtlgyShopifyOrders/orderBulkStatus';
import DrmtlgyOrdersTable from './drmtlgyShopifyOrders/dateWiseOrder';
import DrmtlgyReconciliation from './drmtlgyShopifyOrders/reconciliation';
import Navbar from './components/navbar';
import AdminLogin from './components/adminLogin';
import Dashboard from './components/adminDashboard';
import ProtectedRoute from './components/protectedRoute';
import React from 'react';
import axios from 'axios';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

function AppContent() {
  const isAuthenticated = localStorage.getItem("adminToken");

  // Set auth header synchronously so child components have it on first render
  if (isAuthenticated) {
    axios.defaults.headers.common.Authorization = `Bearer ${isAuthenticated}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }

  // Show navbar only when authenticated (on all protected routes)
  const showNavbar = isAuthenticated;

  return (
    <div className="App">
      {showNavbar && <Navbar />}
      <Routes>
        {/* Redirect to dashboard if already authenticated */}
        <Route
          path="/"
          element={
            isAuthenticated ?
              <Navigate to="/dashboard" replace /> :
              <AdminLogin />
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/slackOrderstatus"
          element={
            <ProtectedRoute>
              <FetchOrderStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clientOrderStatus"
          element={
            <ProtectedRoute>
              <ClientOrderStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kitschOrderStatus"
          element={
            <ProtectedRoute>
              <KitschOrderStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kitschTagOrderStatus"
          element={
            <ProtectedRoute>
              <ClientKitschOrderStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kitschOrderDetailUpdate"
          element={
            <ProtectedRoute>
              <KitschOrderDetailUpdate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dihOrderByDate"
          element={
            <ProtectedRoute>
              <OrdersTable />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dihBulkStatus"
          element={
            <ProtectedRoute>
              <OrderBulkStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/drmtlyOrderByDate"
          element={
            <ProtectedRoute>
              <DrmtlgyOrdersTable />
            </ProtectedRoute>
          }
        />
        <Route
          path="/drmtlgyBulkStatus"
          element={
            <ProtectedRoute>
              <DrmtlgyOrderBulkStatus />
            </ProtectedRoute>
          }
        />
        <Route
          path="/drmtlgyReconciliation"
          element={
            <ProtectedRoute>
              <DrmtlgyReconciliation />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
